import axiosInstance from './axios.instance';

const portfolioCommentService = {
  createComment: async (portfolioUserId, type, content) => {
    const response = await axiosInstance.post('/portfolio-comments', {
      portfolioUserId,
      type,
      content
    });
    return response.data;
  },

  getPortfolioComments: async (portfolioUserId, type = null) => {
    const params = type ? { type } : {};
    const response = await axiosInstance.get(`/portfolio-comments/portfolio/${portfolioUserId}`, { params });
    return response.data;
  },

  getMyReceivedComments: async (type = null) => {
    const params = type ? { type } : {};
    const response = await axiosInstance.get('/portfolio-comments/my-received', { params });
    return response.data;
  },

  markCommentAsRead: async (commentId) => {
    const response = await axiosInstance.put(`/portfolio-comments/${commentId}/read`);
    return response.data;
  },

  deleteComment: async (commentId) => {
    const response = await axiosInstance.delete(`/portfolio-comments/${commentId}`);
    return response.data;
  },

  getUnreadCount: async () => {
    const response = await axiosInstance.get('/portfolio-comments/unread-count');
    return response.data;
  }
};

export default portfolioCommentService;
